import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import TitreAxe from '../components/titre-axe.js'
import SvgPersonnage from "../../images/personnage.svg"
import BtnLePalaisMontcalm from '../components/btn-le-palais-montcalm.js'
import BtnSymeon from '../components/btn-symeon.js'
import BtnCapsuleViolons from '../components/btn-capsule-violons.js'
import BtnViolons from '../components/btn-violons-du-roy.js'
import InfoBox from '../components/info.js'
import DessinHenriette from './../../images/A2P Belley_HMatte.jpg'
import styles from '../components/index.module.css';
import ImageFooter from '../components/image-footer-axe2.js'
import FragAxe2 from '../components/frag-axe2.js'

const SecondPage = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'fondations'}}/>
        <SidebarLeft>
          <div style={{width : "100%", height: "764px", display: "flex", flexDirection: "column", justifyContent: "space-between",alignItems: "flex-end", paddingBottom: "1.45rem"}}>
            <div style={{maxWidth: "520px", width: "70%", height: "auto", alignSelf: "center"}}>
                <div className='metadata--wrapper'>
                    <img src={DessinHenriette} alt=""/>
                    <InfoBox>Henriette Belley est un personnage. Illustration de Hema, Ludovica, 2017.</InfoBox>
                </div>
            </div>
        </div>
        </SidebarLeft>
        <Container>
            <TitreAxe>Monuments</TitreAxe>
            <SvgPersonnage/>
            <h1>Henriette Belley<br/><span className={styles['date']}>1905 - 1980</span></h1>
            <p>Surnommée la merveilleuse folle de Québec, Henriette Belley est née à Beauport dans une famille modeste. Cartomancienne de métier, elle est une cliente régulière et attendue des grands spectacles du Capitole et du Palais Montcalm. Résidente du quartier St-Jean Baptiste pendant de longues années, c'est par ses sorties vespérales que madame Belley se fait remarquer: son extravagance et ses costumes marquent les imaginaires et l'ambiance des grands soirs. En 1971, sa collection de parures (700 costumes, 500 chapeaux et 300 manteaux) sera au coeur d'une exposition que le Musée du Québec lui consacre.</p>
            <FragAxe2/>
        </Container>
        <SidebarRight>
            <BtnCapsuleViolons/>
            <BtnLePalaisMontcalm/>
            <BtnSymeon/>
            <BtnViolons/>
        </SidebarRight>
    </FlexContainer>
    <ImageFooter/>
    </div>
)

export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/henriette-belley.js